module.exports = __webpack_public_path__ + "e07c85c35f2d5369e78b8ada40d1bad5.svg";